import React from "react";
import { Card, CardContent } from "./components/ui/card";
import { Ticket } from "lucide-react";

// "Accompanying person: 2 · Free ticket: 1" — counts, not money.
export const FreeTicketsList = ({ data, testId }) => {
  const entries = Object.entries(data || {});
  if (entries.length === 0) return <span className="text-slate-400">—</span>;
  return (
    <div className="space-y-0.5 text-xs text-slate-600" data-testid={testId}>
      {entries.map(([label, n]) => (
        <div key={label} className="flex justify-between gap-2">
          <span className="truncate">{label}</span>
          <span className="font-semibold text-slate-800">{n}</span>
        </div>
      ))}
    </div>
  );
};

export const FreeTicketsCard = ({ data }) => {
  const total = Object.values(data || {}).reduce((s, n) => s + n, 0);
  return (
    <Card>
      <CardContent className="pt-3 pb-2 px-3">
        <div className="flex items-center gap-2 mb-1">
          <div className="h-6 w-6 rounded flex items-center justify-center bg-slate-100 text-slate-600">
            <Ticket className="h-4 w-4" />
          </div>
          <p className="text-[11px] font-medium text-slate-500 uppercase tracking-wide leading-tight">Free / Admin Tickets</p>
        </div>
        <p className="text-lg font-bold text-slate-900" data-testid="summary-free-tickets">{total}</p>
        {total > 0 && <div className="mt-1.5"><FreeTicketsList data={data} testId="summary-free-tickets-breakdown" /></div>}
      </CardContent>
    </Card>
  );
};
